import { render } from "./CookieScreen.vue?vue&type=template&id=e422de28&scoped=true"
import script from "./CookieScreen.vue?vue&type=script&lang=js"
export * from "./CookieScreen.vue?vue&type=script&lang=js"

import "./CookieScreen.vue?vue&type=style&index=0&id=e422de28&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e422de28"]])

export default __exports__